import React from "react";
import { ApprovalAction } from "Shared/types/ApprovalActions";
import { ApprovalActionsCell } from "Components/Shared/ApprovalActionsCell/ApprovalActionsCell";
import { successToast } from "Modules/DPToast";
import { useUpdateBatchDisbursement } from "./useUpdateBatchDisbursement";
import { handleValidationErrors } from "Modules/HandleValidationErrors";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";

export interface BatchDisbursementActionsProps {
  batchDisbursementId: string;
}

export const BatchDisbursementActions = ({
  batchDisbursementId,
}: BatchDisbursementActionsProps) => {
  const { updateBatchDisbursement } = useUpdateBatchDisbursement();

  const onConfirmAction = async (action: ApprovalAction) => {
    AmplitudeProvider.logEvent({
      type:
        action === ApprovalAction.approve
          ? AmplitudeEventType.ApproveFileClicked
          : AmplitudeEventType.RejectFileClicked,
      payload: { type: "cycle" },
    });

    try {
      const response = await updateBatchDisbursement(
        action === ApprovalAction.approve,
        batchDisbursementId
      );

      if (response?.data?.updateBatchDisbursement.message) {
        successToast(response.data.updateBatchDisbursement.message, false);
      }
    } catch (err) {
      handleValidationErrors(err);
    }
  };

  const getModalText = (action: ApprovalAction) => {
    return action === ApprovalAction.approve
      ? "Click \"Approve File\" to confirm the payments from the uploaded file."
      : "Click \"Reject File\" to reject the payments from the uploaded file.";
  };

  const getButtonText = (action: ApprovalAction) => {
    return `${action.toLowerCase()} file`;
  };

  return (
    <ApprovalActionsCell
      actions={[ApprovalAction.approve, ApprovalAction.reject]}
      getModalText={getModalText}
      getButtonText={getButtonText}
      onConfirmAction={onConfirmAction}
    />
  );
};
